module.exports = __webpack_public_path__ + "static/media/github-hover.9122402a.svg";